import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { MediaModel } from 'src/app/_model/media/media.model';
import { PropertyModel } from 'src/app/_model/property/property.model';
import { VideoMarketingService } from 'src/app/_service/video-marketing.service';

/**
 * A generic configurable dialog used to replace the browser's default dialogs with a prettier one
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'video-marketing-link',
    template: `
    <div class="col-center w-100 align-items"
        style="padding:1rem;box-sizing:border-box;row-gap:0.5rem">
      <div class="row align-items" style="column-gap:0.5rem">
        <img src="/assets/supreme-icon.ico" height="20" width="20" />
        <b>Create a Professional Marketing Video</b>
      </div>
      <span class="text-center">Supreme Video automatically generates a video from your listing data—ready to share in minutes.</span>
      <button mat-flat-button color="primary" class="w-100" [disabled]="disableCreate" (click)="toVideoMarketing()">
        <div *ngIf="!navigating else showSpinner">Create with Supreme Video</div>
        <ng-template #showSpinner><mat-spinner diameter="20"></mat-spinner></ng-template>
      </button>
    </div>
  `,
    styleUrls: ['./video-marketing-link.scss'],
    standalone: false
})
export class VideoMarketingLink {

  public navigating: boolean = false;
  @Input() images: MediaModel[] = null;
  @Input() public set listing(listing: PropertyModel) {
    this._listing = listing;
    this.cdr.detectChanges();
  }
  private _listing: PropertyModel = null;

  public get disableCreate(): boolean {
    return this.navigating || !this._listing || this._listing.MlsStatus === 'Draft' || !this._listing.permissions.Update;
  }

  constructor(
    private videoMarketingService: VideoMarketingService,
    private cdr: ChangeDetectorRef
  ) {}

  /**
   * Brings the user to video marketing to create an advertising video.
   */
  public async toVideoMarketing() {
    this.navigating = true;
    this.cdr.detectChanges();
    this.videoMarketingService.toVideoMarketing(this._listing, this.images).finally(() => {
      this.navigating = false;
      this.cdr.detectChanges();
    });
  }
}
